document.addEventListener("DOMContentLoaded", function () {
  // ==========================
  // Desktop Tabs
  // ==========================
  document.querySelectorAll(".product-details-tabs").forEach(function (section) {
    const nav = section.querySelector(".product-tabs-nav");
    const panels = section.querySelectorAll(".product-tab-panel");
    const buttons = section.querySelectorAll(".product-tab-btn");

    if (!nav || !panels.length) return;

    nav.addEventListener("click", function (event) {
      const button = event.target.closest(".product-tab-btn");
      if (!button || button.classList.contains("active")) return;

      const target = button.dataset.tab;

      buttons.forEach(function (btn) {
        btn.classList.remove("active");
      });

      panels.forEach(function (panel) {
        panel.classList.remove("active");
      });

      button.classList.add("active");

      const activePanel = section.querySelector("#" + target);
      if (activePanel) {
        activePanel.classList.add("active");
      }
    });
  });

  // ==========================
  // Mobile Accordion
  // Native <details> handles open/close with zero layout thrashing.
  // Auto-close sibling accordions using native toggle event.
  // ==========================
  document.querySelectorAll(".product-tabs-mobile-accordion").forEach(function (accordionGroup) {
    const items = accordionGroup.querySelectorAll(".product-tab-accordion-item");
    if (!items.length) return;

    accordionGroup.addEventListener("toggle", function (event) {
      const target = event.target;
      if (!target.open) return;

      items.forEach(function (item) {
        if (item !== target && item.open) {
          item.open = false;
        }
      });
    }, true);
  });
});